import { render } from "./Benutzer.vue?vue&type=template&id=54de5a30"
import script from "./Benutzer.vue?vue&type=script&lang=ts"
export * from "./Benutzer.vue?vue&type=script&lang=ts"

import "./Benutzer.vue?vue&type=style&index=0&id=54de5a30&lang=scss"
script.render = render

export default script